export default __webpack_public_path__ + "static/media/Venturer's Belt of the Yellow Spring.465fb600.jpg";